import script from "./LoadingAnimation.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingAnimation.vue?vue&type=script&setup=true&lang=js"

import "./LoadingAnimation.vue?vue&type=style&index=0&id=755a6cb2&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-755a6cb2"]])

export default __exports__